import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Input,
  Button
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardDFInterfaceUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardDFInterfaceUX-div-0"
        style={{height:"100%",padding:"10px"}}>
        <div
          className="ui form"
          id="CardDFInterfaceUX-div-1"
          style={{padding: "10px 5px 15px", marginBottom: "-10px"}}>

          <FormGroup
            id="CardDFInterfaceUX-FormGroup-4"
            inline={true}
            style={{ marginBottom: "0px"}}>
            <FormField
              id="CardDFInterfaceUX-FormField-7"
              width={2}>
              <label
                id="CardDFInterfaceUX-label-20">
                วันที่สร้าง
              </label>
            </FormField>
            <FormField
              id="CardDFInterfaceUX-FormField-8"
              width={2}>
              <label
                id="CardDFInterfaceUX-label-21">
                HN
              </label>
            </FormField>
            <FormField
              id="CardDFInterfaceUX-FormField-9"
              width={2}>
              <label
                id="CardDFInterfaceUX-label-22">
                Service ID
              </label>
            </FormField>
            <FormField
              id="CardDFInterfaceUX-FormField-10"
              width={2}>
              <label
                id="CardDFInterfaceUX-label-23">
                Product ID
              </label>
            </FormField>
            <FormField
              id="CardDFInterfaceUX-FormField-11"
              width={2}>
              <label
                id="CardDFInterfaceUX-label-24">
                Bil Doc No
              </label>
            </FormField>
            <FormField
              id="CardDFInterfaceUX-FormField-12"
              width={2}>
              <label
                id="CardDFInterfaceUX-label-25">
                {"\u00A0"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardDFInterfaceUX-FormGroup-13"
            inline={true}>
            <FormField
              id="CardDFInterfaceUX-FormField-14"
              width={2}>
              <div
                id="CardDFInterfaceUX-div-26"
                style={{ width: "100%" }}>

                <DateTextBox
                  id="CardDFInterfaceUX-DateTextBox-36"
                  onChange={props.onChangeDate}
                  value={props.searchDF?.createdDate}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardDFInterfaceUX-FormField-15"
              width={2}>
              <div
                id="CardDFInterfaceUX-div-27"
                style={{ width: "100%" }}>

                <Input
                  id="CardDFInterfaceUX-Input-37"
                  name="hn"
                  onChange={props.onChangeData}
                  value={props.searchDF?.hn || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardDFInterfaceUX-FormField-16"
              width={2}>
              <div
                id="CardDFInterfaceUX-div-28"
                style={{ width: "100%" }}>

                <Input
                  id="CardDFInterfaceUX-Input-38"
                  name="serviceId"
                  onChange={props.onChangeData}
                  value={props.searchDF?.serviceId || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardDFInterfaceUX-FormField-17"
              width={2}>
              <div
                id="CardDFInterfaceUX-div-29"
                style={{ width: "100%" }}>

                <Input
                  id="CardDFInterfaceUX-Input-39"
                  name="productId"
                  onChange={props.onChangeData}
                  value={props.searchDF?.productId || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardDFInterfaceUX-FormField-18"
              width={2}>
              <div
                id="CardDFInterfaceUX-div-30"
                style={{ width: "100%" }}>

                <Input
                  id="CardDFInterfaceUX-Input-40"
                  name="bilDocNo"
                  onChange={props.onChangeData}
                  value={props.searchDF?.bilDocNo || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardDFInterfaceUX-FormField-19"
              width={2}>
              <div
                id="CardDFInterfaceUX-div-31"
                style={{ width: "100%", display: "flex" }}>

                <div
                  id="CardDFInterfaceUX-div-41"
                  style={{ margin: "0px 20px" }}>

                  <div
                    id="CardDFInterfaceUX-div-43">
                    {props.searchButton}
                  </div>
                </div>
                <div
                  id="CardDFInterfaceUX-div-42">

                  <Button
                    color="orange"
                    id="CardDFInterfaceUX-Button-44"
                    onClick={props.onClearFilter}>
                    Clear
                  </Button>
                </div>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardDFInterfaceUX-div-2">

          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.tableHeaders}
            data={props.dfInterfaceList}
            id="CardDFInterfaceUX-Table-6"
            minRows="5"
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
        <div
          className="ui form"
          id="CardDFInterfaceUX-div-3"
          style={{ marginTop: "20px" }}>

          <FormGroup
            id="CardDFInterfaceUX-FormGroup-5"
            inline={true}
            style={{ justifyContent: "flex-end" }}>
            <FormField
              id="CardDFInterfaceUX-FormField-32"
              inline={true}>
              <div
                id="CardDFInterfaceUX-div-34">
                {props.addButton}
              </div>
            </FormField>
            <FormField
              id="CardDFInterfaceUX-FormField-33"
              inline={true}>
              <div
                id="CardDFInterfaceUX-div-35">
                {props.editButton}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardDFInterfaceUX

export const screenPropsDefault = {}

/* Date Time : Mon Jul 14 2025 18:17:37 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 5px 15px\", marginBottom: \"-10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"20px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"0px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormGroup-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ justifyContent: \"flex-end\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 6,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "data": {
          "type": "code",
          "value": "props.dfInterfaceList"
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-Table-6"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-7"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-8"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-9"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-10"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-11"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-12"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormGroup-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-14"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-15"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-16"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-17"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-18"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-19"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่สร้าง"
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-label-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-label-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "Service ID"
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-label-22"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "Product ID"
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-label-23"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "Bil Doc No"
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-label-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-label-25"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\" }"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-32"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-FormField-33"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 32,
      "props": {
        "children": {
          "type": "code",
          "value": "props.addButton"
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-34"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editButton"
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-35"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 36,
      "name": "DateTextBox",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-DateTextBox-36"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.searchDF?.createdDate"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Input",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-Input-37"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDF?.hn || \"\""
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "Input",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-Input-38"
        },
        "name": {
          "type": "value",
          "value": "serviceId"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDF?.serviceId || \"\""
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "Input",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-Input-39"
        },
        "name": {
          "type": "value",
          "value": "productId"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDF?.productId || \"\""
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "Input",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-Input-40"
        },
        "name": {
          "type": "value",
          "value": "bilDocNo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchDF?.bilDocNo || \"\""
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px\" }"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-42"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchButton"
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-div-43"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Button",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": "Clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardDFInterfaceUX-Button-44"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClearFilter"
        }
      },
      "seq": 44,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardDFInterfaceUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
